import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const benefits = ['Fahrzeuge & Roboter von Grund auf gebaut', 'Bebilderte Schritt-für-Schritt-Anleitungen', 'Schwierigkeitsgrade: leicht, mittel & anspruchsvoll', 'MINT-Fähigkeiten: Technik, Logik & Kreativität', 'Regelmäßig neue Projekte', 'Perfekt zum Alleinspielen oder als Eltern-Kind-Zeit'];
const projects = [{
  img: 'https://cdn.magicpatterns.com/uploads/cBBDxnMb4mJFhDnHyQDyxY/IMG_1070.png',
  alt: 'Kreatives Projekt mit Flasche und Büroklammern'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/85ppJUoEtmvkUbWcpaDyq7/IMG_1069.webp',
  alt: 'Karton-Aufzug mit leuchtender Ampel'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/acBuwab2CXMr2jfQVqrpi6/IMG_1068.webp',
  alt: 'Programmierbarer Roboterarm'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/oURkoCn4YJBQPNbRdnBCWU/IMG_1067.png',
  alt: 'Wasserspender aus Karton'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/wvbckmE64dGniQpkQvKqY8/IMG_1066.png',
  alt: 'Roboterhand mit Mechanik'
}];
export function ProjectsCarousel() {
  const prefersReducedMotion = useReducedMotion();
  const loopedProjects = [...projects, ...projects];
  return <section className="w-full overflow-hidden bg-white py-16 sm:py-24" data-id="element-153">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-154">
        <SectionHeading eyebrow="Was dein Kind bekommt" title={<>100+ Projekte, die wirklich funktionieren</>} subtitle="Jedes Projekt ist getestet, bebildert und in einfacher Sprache geschrieben, der dein Kind folgen kann — oder gemeinsam mit dir." data-id="element-155" />
      </div>

      <div className="mt-12 w-full overflow-hidden" aria-label="Auswahl der MakerLab-Projekte" data-id="element-156">
        <motion.div className="flex w-max gap-3 px-1 sm:gap-5" animate={prefersReducedMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={prefersReducedMotion ? undefined : {
        duration: 34,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-157">
          {loopedProjects.map((project, index) => <div key={`${project.alt}-${index}`} aria-hidden={index >= projects.length} className="h-36 w-24 flex-none overflow-hidden rounded-2xl border border-ink/10 bg-cream shadow-sm sm:h-48 sm:w-36" data-id="element-158">
              <img src={project.img} alt={index < projects.length ? project.alt : ''} className="h-full w-full object-cover" data-id="element-159" />
            </div>)}
        </motion.div>
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-160">
        <ul className="mt-12 grid gap-x-8 gap-y-4 rounded-3xl border border-ink/10 bg-cream p-8 sm:grid-cols-2" data-id="element-161">
          {benefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm font-medium text-ink" data-id="element-162">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand text-white" data-id="element-163">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-164" />
              </span>
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}